(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.details-and-figures
  (:require
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))

(defn details-and-figures-section
  [{:keys [major-tenants
           current-portfolio
           investment-summary
           exited-portfolio
           limited-partners
           nav-breakdown
           inrev-nav]}
   props]
  [section
   "Details and figures"
   (str "details-and-figures-"
        (some->> props
                 :report
                 :db/id))
   [:div
    [tabular-card/dynamic-table "Current portfolio, €" current-portfolio props]
    [tabular-card/dynamic-table "Exited portfolio, €" exited-portfolio props]
    [tabular-card/dynamic-table "Investment summary, €" investment-summary props]]])
